import { AppButton, AppTextField } from 'components';
import { useContext, useState } from 'react';
import { UserContext } from 'context/UserContext';
import useToaster from 'hooks/useToaster';
import useUpdateProfile from 'hooks/API/useUpdateProfile';
import useUploadImage from 'hooks/API/POST/useUploadImage';
import { useHistory } from 'react-router-dom';

function UpdateProfile() {
  const { userInfo = {} } = useContext(UserContext);
  const { data = {} } = userInfo || {};
  const { mutate, isLoading, isError } = useUpdateProfile();
  const profileName = data.name || {};
  const [name, handleName] = useState(profileName);
  const history = useHistory();

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleProfileUpdate() {
    if (isLoading) return;
    const data = { name };
    mutate(data);
  }

  function handleChange() {
    history.push(`/changePassword`);
  }
  function startUploading(e) {}

  return (
    <>
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0 boldtitle">Update Profile</h2>
            </div>
            <div className="col-6 prime-head text-right">
              <input type="file" onChange={(e) => startUploading(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <AppTextField
                labelProps={{
                  label: 'Name *',
                  htmlFor: 'name',
                }}
                inputProps={{
                  placeholder: 'Name *',
                  id: 'userName',
                  name: 'userName',
                  value: name,
                  onChange: (event) => handleName(event.target.value),
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-row mt-4">
            <div className="aligncenter savecancelbtnsec">
              <AppButton
                variantClass="btn-primary mx-3"
                style={{ minWidth: '1.5rem' }}
                onClick={handleProfileUpdate}
                disabled={isLoading}
              >
                Update
              </AppButton>
              <AppButton variantClass="btn-plane p--tint mx-3" onClick={handleChange}>
                Change Password
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default UpdateProfile;
